import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import api from './api';

const VerificationCodeDialog = ({ open, onClose, onVerifySuccess, onRateLimited, email, code, setCode }) => {
  const [error, setError] = useState('');
  const theme = useTheme();

  const handleVerify = async () => {
    setError('');
    try {
      const res = await api.post('/mfa', { userEmail: email, mfaCode: code });
      const userData = res.data.result;
      const user = { ...userData, authentication: userData.token ?? userData.authentication };
      localStorage.setItem('user', JSON.stringify(user));
      onVerifySuccess(); // notify parent to close and redirect
    } catch (err) {
      if (err.response?.status === 429) {
        onRateLimited();
      } else {
        setError('Invalid verification code');
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>We emailed a 6-digit verification code to {email}</DialogTitle>
      <DialogContent>
        {error && (
          <div style={{ color: 'red', marginBottom: '1rem' }}>{error}</div>
        )}
        <TextField
          placeholder="6-digit Code"
          fullWidth
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={handleVerify}
          color="primary"
          variant="contained"
          disabled={!code}
          style={{
            color: !code ? theme.palette.text.disabled : theme.palette.primary.contrastText
          }}
        >
          Verify
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VerificationCodeDialog;